import React, { useState, useEffect } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";
import ImageTag from "../../reusebale/imageTag";
import { useSelector } from "react-redux"
import BaseUrl from "../../../constants/BaseUrl"
const RecordSection = ({ onNotificationClick }) => {
  const { rightPanel } = db;
  const { loader, loginSuccess, loginError } = useSelector((state) => state.auth)


  const [CountData, setCountData] = useState()
  const GetAllCount = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${BaseUrl}landlord/auth/getAllCountByLandlordId/${loginSuccess.user._id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setCountData(result)
        }
      })
      .catch((error) => console.error(error));
  }

  // Format total collected as currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "$0.00";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  useEffect(() => {
    GetAllCount()
  }, [])

  return (
    <div className="w-full pt-4">
      <div className="flex bg-white rounded-2xl py-5 px-5 mt-6 w-full shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
        <div className="w-[18%] flex items-center justify-between">
          <div className="w-[25%]">
            <ImageTag
              path="/assets/daashboard/tenants-color.png"
              classes="w-full h-full"
              altText="tenants"
            />
          </div>
          <div className="w-[70%] pl-1">
            <ParagraphTag
              content={rightPanel.tenants}
              classes="text-black/40 font-popinsRegular text-sm"
            />
            <ParagraphTag
              content={CountData?.tenantCount}
              classes="text-black font-popinsBold text-xl"
            />
          </div>
        </div>
        <div className="w-[18%] flex items-center justify-between">
          <div className="w-[25%]">
            <ImageTag
              path="/assets/daashboard/properties-color.png"
              classes="w-full h-full"
              altText="tenants"
            />
          </div>
          <div className="w-[70%] pl-1">
            <ParagraphTag
              content={rightPanel.properties}
              classes="text-black/40 font-popinsRegular text-sm"
            />
            <ParagraphTag
              content={CountData?.totalProperties}
              classes="text-black font-popinsBold text-xl"
            />
          </div>
        </div>
        <div className="w-[18%] flex items-center justify-between">
          <div className="w-[25%]">
            <ImageTag
              path="/assets/daashboard/units-color.png"
              classes="w-full h-full"
              altText="tenants"
            />
          </div>
          <div className="w-[70%] pl-1">
            <ParagraphTag
              content={rightPanel.units}
              classes="text-black/40 font-popinsRegular text-sm"
            />
            <ParagraphTag
              content={CountData?.totalUnits}
              classes="text-black font-popinsBold text-xl"
            />
          </div>
        </div>
        <div className="w-[23%] flex items-center justify-between">
          <div className="w-[20%]">
            <ImageTag
              path="/assets/daashboard/price.png"
              classes="w-full h-full"
              altText="tenants"
            />
          </div>
          <div className="w-[75%] pl-1">
            <ParagraphTag
              content={rightPanel.collected}
              classes="text-black/40 font-popinsRegular text-sm"
            />
            <ParagraphTag
              content={formatCurrency(CountData?.totalCollected || 0)}
              classes="text-black font-popinsBold text-xl"
            />
          </div>
        </div>
        <div className="w-[23%] flex items-center justify-between">
          <div className="w-[20%]">
            <ImageTag
              path="/assets/daashboard/price.png"
              classes="w-full h-full"
              altText="tenants"
            />
          </div>
          <div className="w-[75%]">
            <ParagraphTag
              content={rightPanel.pending}
              classes="text-black/40 font-popinsRegular text-sm"
            />
            <ParagraphTag
              content="$25,000"
              classes="text-black font-popinsBold text-xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordSection;
